import { GATSBY_MAIN_URL } from '../../../../constants/env'
import { BadgeType } from '../../../../types'
import { HeaderDropdownItemProps } from '../../ui/HeaderDropdownItem/types'

export const DROPDOWN_COPYTRADING_OPTIONS: HeaderDropdownItemProps[] = [
  {
    to: `${GATSBY_MAIN_URL}/app/copytrading`,
    text: 'Copy proven traders on autopilot in one-click',
    name: 'Start Copy Trading',
    badge: BadgeType.Hot,
  },
  {
    to: `/copytrading`,
    name: 'Copy Trading overview',
    text: 'What is copy trading? Why is Margex Copy Trading the best solution on the market?',
  },
  {
    to: `${GATSBY_MAIN_URL}/app/copytrading/create`,
    name: 'Create a public strategy',
    text: 'And earn together with your followers!',
  },
  {
    to: `${GATSBY_MAIN_URL}/how-to-follow-a-strategy-quick-start`,
    name: 'How to Start Following a Public Trader?',
    text: 'Simple instructions on how to start following a trader',
  },
]
